import './style.scss';
import { TranslationService } from '../../../../services/translation.service';
import Spinner from '../../Spinner';

function PaginatedList({
  children,
  preListItem,
  className = '',
  previousButtonDisabled = false,
  nextButtonDisabled = false,
  showSpinnerTop = false,
  showSpinnerBottom = false,
  onPreviousClick,
  onNextClick,
}: {
  children: React.ReactNode;
  preListItem?: React.ReactNode;
  className?: string;
  previousButtonDisabled?: boolean;
  nextButtonDisabled?: boolean;
  showSpinnerTop?: boolean;
  showSpinnerBottom?: boolean;
  onPreviousClick?: () => void;
  onNextClick?: () => void;
}) {
  return (
    <div className={`paginated-list ${className}`}>
      <div className="w-100 d-flex justify-content-center align-items-center">
        <button disabled={previousButtonDisabled} onClick={onPreviousClick} className="btn--unstyled px-3 py-3 paginated-list__pagination">
          {TranslationService.get('common.earlier')}
        </button>
      </div>
      {preListItem && <div className="bg-blue paginated-list__results border-bottom border-blue p-3">{preListItem}</div>}
      <ul className="bg-blue paginated-list__results list-unstyled">
        {showSpinnerTop && (
          <li key={9999}>
            <Spinner className="pt-4 pb-3" />
          </li>
        )}
        {children}
        {showSpinnerBottom && (
          <li key={-9999}>
            <Spinner className="pt-4 pb-3" />
          </li>
        )}
      </ul>
      <div className="w-100 d-flex justify-content-center align-items-center">
        <button disabled={nextButtonDisabled} onClick={onNextClick} className="btn--unstyled p-3 paginated-list__pagination">
          {TranslationService.get('common.later')}
        </button>
      </div>
    </div>
  );
}

export default PaginatedList;
